import { IconButton } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import Modal from 'global/components/modal';
import colors from 'global/styles/colors';
import { get, size } from 'global/lib/lodash';
import Form from 'global/components/form';
import sendData from 'redux/actions/sendData';
import Alert from '@material-ui/lab/Alert';
import CloseIcon from '@material-ui/icons/Close';
import { validateEmail } from 'global/utils';

export const HelpModal = (props) => {
  const [formState, setFormState] = useState({
    email: '',
    notes: '',
  });

  const [state, setState] = useState({
    alert: null,
    success: false,
  });

  const cancel = () => {
    props.onClose();
  };

  const submit = async () => {
    try {
      setState((s) => ({ ...s, alert: null }));

      const result = await sendData(
        {
          url: `/email-login-help`,
          method: 'post',
          data: {
            data: formState,
          },
        },
        {
          useNamespace: false,
          useAuth: false,
        }
      );

      setState({
        alert: {
          severity: 'success',
          message: `An email has been sent to you and the primary contact(s) in your organization to help you.`,
        },
        success: true,
      });
    } catch (err) {
      setState({
        alert: {
          severity: 'error',
          message: `No organization was found matching your email. If you’d like to learn more about PERFORM, please visit our website at <a target="_blank" href="http://www.performwithibacos.com">http://www.performwithibacos.com</a>.`,
        },
      });
    }
  };

  const reset = () => {
    setFormState({
      email: '',
      notes: '',
    });
    setState({
      alert: null,
      success: false,
    });
  };

  useEffect(() => {
    if (!props.open) {
      reset();
    }
  }, [props.open]);

  const emailValid = validateEmail(formState.email);
  const notesTooBig = size(formState.notes) > 500;
  const submitDisabled = !emailValid || !formState.notes || notesTooBig;

  const buttons = [
    !state.success && { title: 'Cancel', bgColor: colors.danger, onClick: cancel },
    !state.success && { title: 'Submit', onClick: submit, disabled: submitDisabled },
    state.success && { title: 'Close', onClick: cancel },
  ].filter((f) => !!f);

  return (
    <Modal
      title={state.success ? 'Success' : 'Please enter your email address and a short description of what you need, and we’ll connect you with the right person.'}
      {...props}
      buttons={buttons}
    >
      <div>
        {!!state.alert && (
          <Alert
            {...state.alert}
            action={
              <IconButton aria-label="close" color="inherit" size="small" onClick={() => setState((s) => ({ ...s, alert: null }))}>
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            <span dangerouslySetInnerHTML={{ __html: state.alert.message }} />
          </Alert>
        )}

        {!state.success && (
          <Form
            onFormState={(fs) => setFormState(fs)}
            showAllScreens={true}
            screens={[
              {
                title: '',
                inputs: [
                  {
                    id: 'email',
                    type: 'TextField',
                    defaultValue: () => get(formState, 'email', ''),
                    props: {
                      label: 'Business Email',
                    },
                  },
                  {
                    id: 'notes',
                    type: 'TextField',
                    defaultValue: () => get(formState, 'notes', ''),
                    props: {
                      label: 'Notes',
                      rows: 10,
                      multiline: 'true',
                      error: notesTooBig,
                      helperText: notesTooBig ? 'Notes are limited to 500 characters.' : undefined,
                    },
                  },
                ],
              },
            ]}
          />
        )}
      </div>
    </Modal>
  );
};
